/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menufullpublished2Inputs */

const en_menufullpublished2 = /** @type {(inputs: Menufullpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu is live`)
};

const de_menufullpublished2 = /** @type {(inputs: Menufullpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte ist live`)
};

/**
* | output |
* | --- |
* | "Menu is live" |
*
* @param {Menufullpublished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufullpublished2 = /** @type {((inputs?: Menufullpublished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufullpublished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufullpublished2(inputs)
	return de_menufullpublished2(inputs)
});
export { menufullpublished2 as "menuFullPublished" }